import { Avatar, Menu, Portal, defineStyle } from "@chakra-ui/react";

const ringCss = defineStyle({
  outlineWidth: "2px",
  outlineColor: "colorPalette.500",
  outlineOffset: "2px",
  outlineStyle: "solid",
});

interface AvatarMenuProps {
  name: string;
  imgSrc?: string;
  signout: () => void;
}

const AvatarMenu = ({ name, imgSrc, signout }: AvatarMenuProps) => {
  return (
    <Menu.Root positioning={{ placement: "bottom-end" }}>
      <Menu.Trigger rounded="full" focusRing="outside">
        <Avatar.Root css={ringCss} size='2xs' _hover={{ cursor: "pointer" }}>
          <Avatar.Fallback name={name} />
          {imgSrc && <Avatar.Image src={imgSrc} referrerPolicy="no-referrer" />}
        </Avatar.Root>
      </Menu.Trigger>
      <Portal>
        <Menu.Positioner>
          <Menu.Content>            
            <Menu.Item
              onClick={signout}
              color="red.600"
              value="Sign out"
              _hover={{ cursor: "pointer" }}
            >
              Sign out
            </Menu.Item>
          </Menu.Content>
        </Menu.Positioner>
      </Portal>
    </Menu.Root>
  );
};

export default AvatarMenu;
